import './App.css';
import React from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import { Partytown } from '@builder.io/partytown/react';
import {Helmet} from "react-helmet";

const WorldPagesNavigation = React.lazy(() => import(   './pages/navigation/WorldPagesNavigation'));
const DebtClockNavigation = React.lazy(() => import(   './pages/navigation/DebtClockNavigation'));
const GDPClockNavigation = React.lazy(() => import(   './pages/navigation/GDPClockNavigation'));
const PopulationClockNavigation = React.lazy(() => import(   './pages/navigation/PopulationClockNavigation'));
const HomeGlobe = React.lazy(() => import(  "./pages/globe/homeGlobe"));
const Home = React.lazy(() => import( './pages/home'));
const CountryNavigation = React.lazy(() => import( './pages/countryNavigation'));
const About = React.lazy(() => import( './pages/About'));
const Footer = React.lazy(() => import( './components/footer'));
const Header = React.lazy(() => import( './components/header'));
const GdpPage = React.lazy(() => import('./pages/country/gdpPage'));
const World = React.lazy(() => import('./pages/World'));
const debtPage = React.lazy(() => import('./pages/country/debtPage'));
const populationPage = React.lazy(() => import('./pages/country/populationPage'));
const GdpClock = React.lazy(() => import( './pages/country/clocks/gdpClock'));
const DebtClock = React.lazy(() => import( './pages/country/clocks/debtClock'));
const PopulationClock = React.lazy(() => import( './pages/country/clocks/populationClock'));
const CountryPage = React.lazy(() => import( './pages/country/countryPage'));
const PrivacyPolicy = React.lazy(() => import( './pages/privacyPolicy'));
const MathPlot = React.lazy(() => import("./pages/tools/mathPlot.jsx"));
const EquationsExamples = React.lazy(() => import( './pages/tools/EquationsExamples.jsx'));

function wrapHeaderFooter(Component){
  return(
    <div>
      <Header />
      <Component />
      <Footer />
    </div>
  );
}

function App() {
  
  return (
    <BrowserRouter>
       <Helmet>
          <Partytown debug={true} forward={['dataLayer.push']} />
        </Helmet>
      
        <Routes>
            <Route path='PopulationClock/:id' element={<PopulationClock start_time={Date.now()}/>}/>
            <Route path='DebtClock/:id' element={<DebtClock start_time={Date.now()}/>}/>
            <Route path='GDPClock/:id' element={<GdpClock start_time={Date.now()}/>}/>
            <Route path='/:id' element={<CountryPage />}/>
            <Route exact path='/' element={wrapHeaderFooter(Home)}/>
            <Route exact path='/country' element={wrapHeaderFooter(CountryNavigation)}/>
            <Route exact path='/about' element={wrapHeaderFooter(About)}/>
            <Route exact path='/World' element={wrapHeaderFooter(World)}/>
            <Route exact path='/GDP' element={wrapHeaderFooter(GdpPage)}/>
            <Route exact path='/debt' element={wrapHeaderFooter(debtPage)}/>
            <Route exact path='/DebtClockNavigation' element={wrapHeaderFooter(DebtClockNavigation)}/>
            <Route exact path='/GDPNavigation' element={wrapHeaderFooter(GDPClockNavigation)}/>
            <Route exact path='/PopulationNavigation' element={wrapHeaderFooter(PopulationClockNavigation)}/>
            <Route exact path='/WorldNavigation' element={wrapHeaderFooter(WorldPagesNavigation)}/>
            <Route exact path='/population' element={wrapHeaderFooter(populationPage)}/>
            <Route exact path='/privacy-policy' element={wrapHeaderFooter(PrivacyPolicy)}/>
            <Route exact path='/globe' element={<HomeGlobe/>}/>
            <Route exact path='/tools/MathPlot' element={wrapHeaderFooter(MathPlot)}/>
            <Route exact path='/tools/MathPlot/:name' element={wrapHeaderFooter(EquationsExamples)}/>
        </Routes>
    </BrowserRouter>
  );
}

export default App;
